export type SequenceOption = {
  id: string;
  sequence: string;
  expectedResponses: boolean[];
};

export const patternToResponses = (pattern: string) =>
  pattern.split('').map((step) => step === 'H');

/** Preset sequences for local algorithm validation (`constants.localHearingOnly`). */
export const algorithmValidationSequences: SequenceOption[] = [
  {
    id: 'Test A',
    sequence: '45, 65, 85, 85, 85',
    expectedResponses: patternToResponses('MMMMM'),
  },
  {
    id: 'Test B',
    sequence: '45, 35, 40, 45, 35, 40',
    expectedResponses: patternToResponses('HMMHMM'),
  },
  {
    id: 'Test C',
    sequence: '45, 35, 40, 30, 35, 40',
    expectedResponses: patternToResponses('HMHMMH'),
  },
  {
    id: 'Test D',
    sequence: '45, 35, 25, 15, 5, 5, 5',
    expectedResponses: patternToResponses('HHHHHHH'),
  },
  {
    id: 'Test E',
    sequence: '45, 35, 25, 30, 35, 25, 30',
    expectedResponses: patternToResponses('HHMMHMM'),
  },
  {
    id: 'Test F',
    sequence: '45, 35, 25, 30, 20, 25, 30',
    expectedResponses: patternToResponses('HHMHMMH'),
  },
  {
    id: 'Test G',
    sequence: '45, 35, 40, 45, 50, 40, 45',
    expectedResponses: patternToResponses('HMMMHMH'),
  },
  {
    id: 'Test H',
    sequence: '45, 65, 55, 60, 50, 55, 60',
    expectedResponses: patternToResponses('MHMHMMH'),
  },
  {
    id: 'Test I',
    sequence: '45, 65, 55, 60, 65, 55, 60',
    expectedResponses: patternToResponses('MHMMHMM'),
  },
  {
    id: 'Test J',
    sequence: '45, 35, 25, 15, 20, 10, 0, 0',
    expectedResponses: patternToResponses('HHHMHHHH'),
  },
  {
    id: 'Test K',
    sequence: '45, 35, 25, 30, 35, 40, 30, 35',
    expectedResponses: patternToResponses('HHMMMHMH'),
  },
  {
    id: 'Test L',
    sequence: '45, 65, 55, 60, 50, 55, 60, 65, 70, 60, 65, 70',
    expectedResponses: patternToResponses('MHMHMMMMHMMH'),
  },
  /** Special jump: re-test at X+15 dB over loudest qualifying miss (capped at MAX) */
  {
    id: 'Test M',
    sequence: '45, 65, 55, 45, 35, 40, 30, 20, 50, 40, 45, 50',
    expectedResponses: patternToResponses('MHHHMHHMHMMH'),
  },
  /** Special jump (X+15): extended until stopping fires on final trial */
  {
    id: 'Test N',
    sequence: '45, 35, 40, 30, 35, 25, 50, 40, 45, 50, 40, 45',
    expectedResponses: patternToResponses('HMHMHMHMMHMH'),
  },
  /** No special jump: pre-hit miss at 45 does not set X; last miss at 30 → threshold 35 */
  {
    id: 'Test O',
    sequence: '45, 65, 55, 45, 35, 25, 30, 35, 25, 30',
    expectedResponses: patternToResponses('MHHHHMMHMM'),
  },
  /** Special jump (X+15): extended until stopping fires on final trial */
  {
    id: 'Test P',
    sequence: '45, 65, 55, 60, 50, 40, 30, 20, 70, 60, 65, 70, 60, 65',
    expectedResponses: patternToResponses('MHMHHHHMHMMHMH'),
  },
];
